// Режим приложения: сайт открыт как установленное приложение (Android-оболочка TWA или «На экран Домой» на iPhone).
// В нём отключаем «браузерное»: пинч-зум и двойной тап, «резинку» и подтягивание для обновления, выделение текста
// (кроме полей ввода) и меню долгого нажатия. В обычном браузере ничего не меняется.
const STORAGE_KEY = 'appMode';
const APP_VIEWPORT = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover';
const EDITABLE = 'input, textarea, select, [contenteditable="true"], .selectable';

/** Открыт ли сайт как приложение. Признак запоминается на сессию: в TWA «referrer» виден только на первой странице. */
export function isAppMode(win = window) {
  try {
    if (win.sessionStorage && win.sessionStorage.getItem(STORAGE_KEY) === '1') return true;
    const mq = (q) => Boolean(win.matchMedia && win.matchMedia(q).matches);
    const standalone = mq('(display-mode: standalone)') || mq('(display-mode: fullscreen)') || win.navigator.standalone === true;
    const twa = String((win.document && win.document.referrer) || '').startsWith('android-app://');
    if (standalone || twa) {
      try { win.sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* хранилище недоступно */ }
      return true;
    }
  } catch (e) { /* без режима приложения страница работает как обычно */ }
  return false;
}

/** Включает режим приложения: класс на <html>, запрет зума в viewport, слушатели жестов. Возвращает true, если включён. */
export function initAppMode(win = window) {
  if (!isAppMode(win)) return false;
  const doc = win.document;
  doc.documentElement.classList.add('app-mode');

  const meta = doc.querySelector('meta[name="viewport"]');
  if (meta) meta.setAttribute('content', APP_VIEWPORT);

  const editable = (target) => Boolean(target && target.closest && target.closest(EDITABLE));
  // iPhone: жест увеличения Safari игнорирует настройки viewport — гасим сами
  ['gesturestart', 'gesturechange', 'gestureend'].forEach((name) => doc.addEventListener(name, (e) => e.preventDefault(), { passive: false }));
  // два пальца на экране — не даём странице масштабироваться
  doc.addEventListener('touchmove', (e) => { if (e.touches && e.touches.length > 1) e.preventDefault(); }, { passive: false });
  // меню долгого нажатия (копировать, поделиться) — только в полях ввода
  doc.addEventListener('contextmenu', (e) => { if (!editable(e.target)) e.preventDefault(); });
  return true;
}
